import { Button, Classes, FormGroup } from "@blueprintjs/core";
import { DefaultSelectedOption, renderSingleOption, SimpleSelect } from "modules/common/services/form/select";
import React, { useCallback } from "react";
import { CommonBusinessEventProps, Error, stageLabel, star } from "./common";
import { EventTypes, fields } from "modules/orders-manage/models/order-events";
import { observer } from "mobx-react";

const Base = ({ event, readonly, stages, isNotStateChange }: CommonBusinessEventProps) => {
  const { value, validate } = event.model;
  let stage = null;
  if (value) {
    stage = stages.find((o) => o.stage.newGuid === value);
  } else {
    stage = stages.find((o) => o.stage.newGuid === event.model.stageGuid);
  }

  const item: SelectItem | null = stage ? { id: stage.stage.newGuid, label: stageLabel(stage) } : null;
  const options = stages.map((o) => ({ id: o.stage.newGuid, label: stageLabel(o) }));

  const onChangeHandler = useCallback(
    (i: SelectItem) => {
      event.model.setValue(fields.stageGuid, i.id);
    },
    [event]
  );
  const valid = !item ? "Необходимо выбрать этап" : null;
  const onChange = (i: SelectItem) => {
    isNotStateChange && isNotStateChange("stageGuid", i.id);
  };

  if (!isNotStateChange)
    return (
      <FormGroup
        labelInfo={star}
        helperText={validate[fields.stageGuid]}
        intent={validate[fields.stageGuid] ? Error : "none"}
        className={Classes.SMALL}
      >
        <div className={`${Classes.INPUT_GROUP}`}>
          <SimpleSelect
            className={`full-width-select ${Classes.FILL}`}
            filterable={false}
            activeItem={item}
            items={options}
            itemRenderer={renderSingleOption}
            onItemSelect={onChangeHandler}
            disabled={readonly}
            popoverProps={{
              usePortal: true,
              rootBoundary: "viewport",
              popoverClassName: "business-event__typeselect-dropdown",
            }}
          >
            {readonly && (
              <Button fill={true} className="selected-option">
                {stage && stageLabel(stage)}
              </Button>
            )}
            {!readonly && <DefaultSelectedOption option={item} empty={!options.length} />}
          </SimpleSelect>
        </div>
      </FormGroup>
    );

  return (
    <div className={`${Classes.INPUT_GROUP}`}>
      <div style={{ color: "red", fontSize: "12px" }}>{valid ? valid : null}</div>
      <SimpleSelect
        className={`full-width-select ${Classes.FILL}`}
        filterable={false}
        activeItem={item}
        items={options}
        itemRenderer={renderSingleOption}
        onItemSelect={onChange}
        disabled={readonly}
        popoverProps={{
          usePortal: true,
          rootBoundary: "viewport",
          popoverClassName: "business-event__typeselect-dropdown",
        }}
      >
        {readonly && (
          <Button fill={true} className="selected-option">
            {stage && stageLabel(stage)}
          </Button>
        )}
        {!readonly && <DefaultSelectedOption option={item} empty={!options.length} />}
      </SimpleSelect>
    </div>
  );
};

Base.TYPE = EventTypes.OrderStageStartedBusinessEvent;

export const OrderStageStartedBusinessEvent = observer(Base);
